import React from 'react';
import { CheckIcon } from 'lucide-react';
const FEATURES = ['Engine & starting diagnostics', 'Fuel & intake troubleshooting', 'Electrical & charging diagnostics', 'ECU, ignition & sensor references', 'Drivetrain, brake & chassis diagnostics', 'Professional fault-finding workflows'];
export function SystemSection() {
  return <section className="border-b border-line bg-panel py-8 sm:py-10" data-id="element-174" data-mp="36jk4ou91ctev">
      <div className="mx-auto max-w-[1080px] px-4 sm:px-6" data-id="element-175" data-mp="31lqw5uk9fnbf">
        <h2 className="text-center text-[23px] font-bold leading-[1.02] text-white sm:text-[36px]" data-id="element-176" data-mp="2wu0gd92k07cm">
          The complete <span className="text-brandorange" data-id="element-177" data-mp="2srvr0mj51wvs">6-in-1</span> motorcycle
          diagnostic system
        </h2>

        <div className="mx-auto mt-5 max-w-[880px] border-2 border-brandorange bg-carbon p-4 sm:p-6" data-id="element-178" data-mp="2nu3qj44fh2fz">
          <p className="text-center font-display text-[20px] uppercase leading-none text-white sm:text-[28px]" data-id="element-179" data-mp="2iuheuz48zu9a">
            🏍️ Motorcycle Diagnostic Pro™
          </p>
          <p className="mt-2 text-center font-display text-[12px] uppercase tracking-[0.14em] text-brandorange sm:text-[15px]" data-id="element-180" data-mp="13z7vl3wwwcna">
            Understand • Identify • Test • Isolate • Diagnose • Verify
          </p>
          <ul className="mt-5 grid gap-2 sm:grid-cols-2 sm:gap-x-6" data-id="element-181" data-mp="u1k2eieyfd78">
            {FEATURES.map(feature => <li key={feature} className="flex items-start gap-2" data-id="element-182" data-mp="yzbw9hz5t9e2">
                <CheckIcon className="mt-[3px] h-4 w-4 shrink-0 text-mod-green" strokeWidth={3.5} data-id="element-183" data-mp="1mppmd2y6oy60" />
                <span className="text-[14px] font-semibold leading-snug text-white sm:text-[16px]" data-id="element-184" data-mp="1rnhcpsj6kc83">
                  {feature}
                </span>
              </li>)}
          </ul>
        </div>
      </div>
    </section>;
}